import { ParsedMathJax } from '../../pages/components/ParsedMathJax';
import { ApiResponse, PatchDocumentFromJSON, WorkApi } from '../../api/core';
import * as React from 'react';
import { NavigateFunction } from 'react-router';
import { IntlShape } from 'react-intl';
import { ToastContextType } from '../providers/ToastProvider';

export const requestDeleteWork = (workApi: WorkApi, toast: ToastContextType, intl: IntlShape, navigate: NavigateFunction, workId: number, workTitle: string, redirectPath?: string): void => {
  toast.confirm({
    message:
      <ParsedMathJax content={intl.formatMessage({id: 'work.deleteRequest.popup.message(workTitle)'}, {workTitle})} />,
    header: intl.formatMessage({id: 'work.deleteRequest.popup.label'}),
    icon: 'pi pi-info-circle',
    defaultFocus: 'reject',
    acceptClassName: 'p-button-danger',
    acceptLabel: intl.formatMessage({id: 'button.confirm'}),
    accept: async (): Promise<void> => {
      try {
        await workApi.requestDelete({
          workId,
          patchDocument: [
            PatchDocumentFromJSON({
              op: 'replace',
              path: '/adminDataWork/editorialStatus',
              value: 'deleted',
            }),
          ],
        });
        toast.notify({
          summary: intl.formatMessage({id: 'message.deletionRequest.success.title'}),
          detail: intl.formatMessage({id: 'message.deletionRequest.success.message'}),
          severity: 'success',
        });
        void navigate(redirectPath || '/search/works');
      } catch (e: any) {
        console.error('Deletion request: ', e);
        toast.alert({
          header: intl.formatMessage({id: 'message.deletionRequest.failed.title'}),
          message: intl.formatMessage({id: 'message.deletionRequest.failed.message'}),
        });
      }

    },
    rejectLabel: intl.formatMessage({id: 'button.abort'}),
  });
};

export const deleteWork = (workApi: WorkApi, toast: ToastContextType, intl: IntlShape, navigate: NavigateFunction, workId: number, workTitle: string, redirectPath?: string): void => {
  toast.confirm({
    message:
      <div>
        <p>{intl.formatMessage({id: 'work.delete.popup.message'})}</p>
        <p><strong><ParsedMathJax content={workTitle} /> (ID: {workId})</strong></p>
      </div>,
    header: intl.formatMessage({id: 'work.delete.popup.label'}),
    icon: 'pi pi-info-circle',
    defaultFocus: 'reject',
    acceptClassName: 'p-button-danger',
    acceptLabel: intl.formatMessage({id: 'button.confirm'}),
    accept: async (): Promise<void> => {
      try {
        const response: ApiResponse<void> = await workApi.deleteWorkRaw({workId});
        if (!response.raw.ok) {
          throw new Error(response.raw.statusText);
        }
        toast.notify({
          summary: intl.formatMessage({id: 'message.deletion.success.title'}),
          detail: intl.formatMessage({id: 'message.deletion.success.message'}),
          severity: 'success',
        });
        void navigate(redirectPath || '/search/works');
      } catch (e) {
        console.error('Delete failed: ', e);
        toast.alert({
          header: intl.formatMessage({id: 'message.deletion.failed.title'}),
          message: intl.formatMessage({id: 'message.deletion.failed.message'}),
        });
      }

    },
    rejectLabel: intl.formatMessage({id: 'button.abort'}),
  });
};
